/* eslint-disable no-unused-vars */
(function (Drupal, drupalSettings) {
  Drupal.behaviors.fixMinHeight = {
    attach: function (context, settings) {
      const footer = document.querySelector('footer', context);
      const header = document.querySelector('header', context);

      for (let item of [footer, header]) {
        document.body.style.setProperty(`--${item.tagName.toLowerCase()}-height`, `${item.offsetHeight / 10}rem`);
      }
    }
  };

  Drupal.behaviors.mainNavSubmenu = {
    attach: function (context, settings) {
      const submenuLinks = document.querySelectorAll(
        'span.main-menu__link',
        context
      );

      for (const link of submenuLinks) {
        if (!link.classList.contains('js-event-active')) {
          link.addEventListener('click', (e) => {
            // Remove active class from all els apart target
            submenuLinks.forEach((l, idx) => {
              if (e.currentTarget != submenuLinks[idx]) {
                
                if (submenuLinks[idx].parentElement.classList.contains('js-link-active')) {
                  submenuLinks[idx].parentElement.classList.remove('js-link-active');
                }
              }
            });
            // Toggle active class for target el
            e.target.parentElement.classList.toggle('js-link-active');
          });
          link.classList.add('js-event-active');
        }
      }
    }
  };

  Drupal.behaviors.closeSubnavs = {
    attach: function (context, settings) {
      const body = document.querySelector('body');
      const menuLinks = document.querySelectorAll('.main-menu__item');

      if (!body || !menuLinks) {
        return;
      }

      if (!body.classList.contains('js-body-active')) {
        body.addEventListener('click', (e) => {
          if (!e.target.classList.contains('main-menu__link')) {
            for (const link of menuLinks) {
              if (link.classList.contains('js-link-active')) {
                link.classList.remove('js-link-active');
              };
            }
          }
        });

        body.classList.add('js-body-active');
      }
    }
  };

  Drupal.behaviors.burgerIcon = {
    attach: function (context, settings) {
      const burgerIcon = document.querySelector('.header__burger');
      const mainMenu = document.querySelector('.header__nav-menu');
      const headerContainer = document.querySelector('.header');

      burgerIcon.addEventListener('click', () => {
        const drawerMenuPadding = headerContainer.getBoundingClientRect().bottom;
        mainMenu.style.setProperty('--top-padding', `${drawerMenuPadding}px`);
        burgerIcon.classList.toggle('js-burger-active');
        mainMenu.classList.toggle('js-nav-active');
        document.body.classList.toggle('no-scroll');
      });
    }
  };

  Drupal.behaviors.navAccessibility = {
    attach: function (context, settings) {
      const menuSpans = document.querySelectorAll('span.main-menu__link', context);
      const subMenus = document.querySelectorAll('.main-menu--sub', context);

      // Display submenu
      for (const span of menuSpans) {
        span.tabIndex = 0;
        // Display submenu on space keypress
        span.addEventListener('keypress', (e) => {
          e.preventDefault();
          let charCode = e.keyCode || e.which;
          if (charCode === 32) {
            span.parentElement.classList.toggle('js-link-active');
          }
        });
      }

      // Hide Submenu on leave of last submenu element
      for (const menu of subMenus) {
        const lastEl = menu.lastElementChild;
        if (lastEl) {
          lastEl.addEventListener('focusout', () => {
            const parentEl = lastEl.parentElement.previousElementSibling.parentElement;
            if (parentEl && parentEl.classList.contains('js-link-active')) {
              parentEl.classList.remove('js-link-active');
            }
          });
        }
      }
    }
  };

  Drupal.behaviors.fileSizeValidation = {
    attach: function (context, settings) {
      const fileInput = document.getElementById("edit-field-media-document-0-upload", context);

      if (fileInput && !fileInput.classList.contains('js-event-added')) {

        fileInput.addEventListener('change', () => {
          const file = fileInput.files[0];
          if (file.size/ 1024 / 1024 > 64) { // 64MB limit
            setTimeout(() => {
              alert("File size cannot exceed 64MB. Please upload a new file.");
            }, 2000);
          }
        });
        fileInput.classList.add('js-event-added');
      }
    }
  };

  Drupal.behaviors.iframeStyles = {
    attach: function (context, settings) {
      const iframe = document.querySelector('.entity-browser-modal-iframe');

      if (!iframe) {
        return;
      }

      iframe.addEventListener("load", ev => {
        const new_style_element = document.createElement("style");
        new_style_element.textContent = "html { font-size: 62.5%; } .visually-hidden {display: none};"
        ev.target.contentDocument.head.appendChild(new_style_element);
    });
    }
  };

})(window.Drupal, drupalSettings);
